<template>
    <CFormSwitch
        :size="size"
        @update:model-value="updateChecked"
    />
</template>

<script setup>
import { CFormSwitch } from '@coreui/vue-pro'

defineProps({
    size: {
        type: String,
        default: 'xl'
    }
})

const emit = defineEmits(['update:checked'])

const updateChecked = (...values) => {
    emit('update:checked', ...values)
}
</script>

<style lang="scss">
.form-switch-xl {
    .form-check-input {
        height: 22px;
        width: 32px;
    }
}

.form-switch {
    .form-check-input:checked {
        background-color: #2eb85c;
        border-color: #2eb85c;
    }
}
</style>
